import { render, staticRenderFns } from "./servicerMessage.vue?vue&type=template&id=0cc2b6cc&scoped=true"
import script from "./servicerMessage.vue?vue&type=script&lang=js"
export * from "./servicerMessage.vue?vue&type=script&lang=js"
import style0 from "./servicerMessage.vue?vue&type=style&index=0&id=0cc2b6cc&prod&lang=css"
import style1 from "./servicerMessage.vue?vue&type=style&index=1&id=0cc2b6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc2b6cc",
  null
  
)

export default component.exports